module.exports = __webpack_public_path__ + "img/TOPNET.3df92a9b.png";